import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserIcon, MailIcon, LockIcon, EyeIcon, EyeOffIcon, BuildingIcon } from 'lucide-react';
const Register = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    company: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [errors, setErrors] = useState<{
    [key: string]: string;
  }>({});
  const handleChange = (field: string, value: string) => {
    setFormData({
      ...formData,
      [field]: value
    });
    setErrors({
      ...errors,
      [field]: undefined
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const newErrors: {
      [key: string]: string;
    } = {};
    if (!formData.firstName) newErrors.firstName = 'El nombre es requerido';
    if (!formData.lastName) newErrors.lastName = 'El apellido es requerido';
    if (!formData.company) newErrors.company = 'La empresa es requerida';
    if (!formData.email) {
      newErrors.email = 'El correo electrónico es requerido';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Ingresa un correo electrónico válido';
    }
    if (!formData.password) {
      newErrors.password = 'La contraseña es requerida';
    } else if (formData.password.length < 8) {
      newErrors.password = 'La contraseña debe tener al menos 8 caracteres';
    }
    if (!formData.confirmPassword) {
      newErrors.confirmPassword = 'Confirma tu contraseña';
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Las contraseñas no coinciden';
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    // Aquí iría la lógica de registro
    console.log('Register:', formData);
    navigate('/');
  };
  return <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4" data-id="element-1791">
      <div className="w-full max-w-2xl" data-id="element-1792">
        <div className="bg-white rounded-2xl shadow-xl p-8" data-id="element-1793">
          {/* Logo and Title */}
          <div className="text-center mb-8" data-id="element-1794">
            <h1 className="text-3xl font-bold text-blue-600 mb-2" data-id="element-1795">
              FinancePro
            </h1>
            <p className="text-gray-600" data-id="element-1796">Crea tu cuenta</p>
          </div>
          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-5" data-id="element-1797">
            {/* Name Fields */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1798">
              <div data-id="element-1799">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1800">
                  Nombre
                </label>
                <div className="relative" data-id="element-1801">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1802">
                    <UserIcon size={18} className="text-gray-400" data-id="element-1803" />
                  </div>
                  <input type="text" value={formData.firstName} onChange={e => handleChange('firstName', e.target.value)} className={`w-full pl-10 pr-4 py-2.5 border ${errors.firstName ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all`} placeholder="Ana" data-id="element-1804" />
                </div>
                {errors.firstName && <p className="text-red-500 text-xs mt-1" data-id="element-1805">
                    {errors.firstName}
                  </p>}
              </div>
              <div data-id="element-1806">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1807">
                  Apellidos
                </label>
                <div className="relative" data-id="element-1808">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1809">
                    <UserIcon size={18} className="text-gray-400" data-id="element-1810" />
                  </div>
                  <input type="text" value={formData.lastName} onChange={e => handleChange('lastName', e.target.value)} className={`w-full pl-10 pr-4 py-2.5 border ${errors.lastName ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all`} placeholder="Beltrán" data-id="element-1811" />
                </div>
                {errors.lastName && <p className="text-red-500 text-xs mt-1" data-id="element-1812">{errors.lastName}</p>}
              </div>
            </div>
            {/* Company Field */}
            <div data-id="element-1813">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1814">
                Empresa
              </label>
              <div className="relative" data-id="element-1815">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1816">
                  <BuildingIcon size={18} className="text-gray-400" data-id="element-1817" />
                </div>
                <input type="text" value={formData.company} onChange={e => handleChange('company', e.target.value)} className={`w-full pl-10 pr-4 py-2.5 border ${errors.company ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all`} placeholder="PYME Solutions" data-id="element-1818" />
              </div>
              {errors.company && <p className="text-red-500 text-xs mt-1" data-id="element-1819">{errors.company}</p>}
            </div>
            {/* Email Field */}
            <div data-id="element-1820">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1821">
                Correo electrónico
              </label>
              <div className="relative" data-id="element-1822">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1823">
                  <MailIcon size={18} className="text-gray-400" data-id="element-1824" />
                </div>
                <input type="email" value={formData.email} onChange={e => handleChange('email', e.target.value)} className={`w-full pl-10 pr-4 py-2.5 border ${errors.email ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all`} placeholder="tu@email.com" data-id="element-1825" />
              </div>
              {errors.email && <p className="text-red-500 text-xs mt-1" data-id="element-1826">{errors.email}</p>}
            </div>
            {/* Password Fields */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1827">
              <div data-id="element-1828">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1829">
                  Contraseña
                </label>
                <div className="relative" data-id="element-1830">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1831">
                    <LockIcon size={18} className="text-gray-400" data-id="element-1832" />
                  </div>
                  <input type={showPassword ? 'text' : 'password'} value={formData.password} onChange={e => handleChange('password', e.target.value)} className={`w-full pl-10 pr-12 py-2.5 border ${errors.password ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all`} placeholder="Mínimo 8 caracteres" data-id="element-1833" />
                  <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-1834">
                    {showPassword ? <EyeOffIcon size={18} className="text-gray-400 hover:text-gray-600" data-id="element-1835" /> : <EyeIcon size={18} className="text-gray-400 hover:text-gray-600" data-id="element-1836" />}
                  </button>
                </div>
                {errors.password && <p className="text-red-500 text-xs mt-1" data-id="element-1837">{errors.password}</p>}
              </div>
              <div data-id="element-1838">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1839">
                  Confirmar contraseña
                </label>
                <div className="relative" data-id="element-1840">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1841">
                    <LockIcon size={18} className="text-gray-400" data-id="element-1842" />
                  </div>
                  <input type={showConfirmPassword ? 'text' : 'password'} value={formData.confirmPassword} onChange={e => handleChange('confirmPassword', e.target.value)} className={`w-full pl-10 pr-12 py-2.5 border ${errors.confirmPassword ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all`} placeholder="Repite tu contraseña" data-id="element-1843" />
                  <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-1844">
                    {showConfirmPassword ? <EyeOffIcon size={18} className="text-gray-400 hover:text-gray-600" data-id="element-1845" /> : <EyeIcon size={18} className="text-gray-400 hover:text-gray-600" data-id="element-1846" />}
                  </button>
                </div>
                {errors.confirmPassword && <p className="text-red-500 text-xs mt-1" data-id="element-1847">
                    {errors.confirmPassword}
                  </p>}
              </div>
            </div>
            {/* Terms and Conditions */}
            <div className="flex items-start" data-id="element-1848">
              <input type="checkbox" id="terms" className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-2 focus:ring-blue-500 mt-0.5" required data-id="element-1849" />
              <label htmlFor="terms" className="ml-2 text-sm text-gray-600" data-id="element-1850">
                Acepto los{' '}
                <a href="#" className="text-blue-600 hover:text-blue-700 font-medium" data-id="element-1851">
                  términos y condiciones
                </a>{' '}
                y la{' '}
                <a href="#" className="text-blue-600 hover:text-blue-700 font-medium" data-id="element-1852">
                  política de privacidad
                </a>
              </label>
            </div>
            {/* Submit Button */}
            <button type="submit" className="w-full bg-blue-600 text-white py-2.5 rounded-lg hover:bg-blue-700 transition-colors font-medium" data-id="element-1853">
              Crear cuenta
            </button>
          </form>
          {/* Login Link */}
          <div className="mt-6 text-center" data-id="element-1854">
            <p className="text-sm text-gray-600" data-id="element-1855">
              ¿Ya tienes una cuenta?{' '}
              <Link to="/login" className="text-blue-600 hover:text-blue-700 font-medium" data-id="element-1856">
                Inicia sesión
              </Link>
            </p>
          </div>
        </div>
        {/* Footer */}
        <div className="text-center mt-6" data-id="element-1857">
          <p className="text-sm text-gray-600" data-id="element-1858">
            © 2024 FinancePro. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </div>;
};
export default Register;